export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4647.e2f2d75b.jpg";